import React, { Component } from 'react';
import PropTypes from 'prop-types';

import ListView from '../Common/ListView.react';
import ListItem from './AccessGroupListItem';

import AccessGroupStore from '../../stores/AccessGroupStore';
import AccessGroupActions from '../../actions/AccessGroupActionCreator';

class AccessGroupList extends Component {

    constructor() {
        super(...arguments);
        this.state = {
            accessGroups: [],
            count: 0,
            page: 0,
            limit: 50,
        };
    }

    componentDidMount() {
        this.onChange = this.onChange.bind(this);
        AccessGroupStore.addChangeListener(this.onChange);
        AccessGroupActions.getAll({limit: this.state.limit});
    }

    componentWillUnmount() {
        AccessGroupStore.removeChangeListener(this.onChange);
    }

    render() {

        const isAdmin      = this.context.auth.isAdmin();
        let viewProps = {
            title:         'Access groups',
            items:         this.state.accessGroups,
            itemDecorator: ListItem,
        };

        if (isAdmin) {
            viewProps.newEntityUrl = '/dashboard/accessgroup/new';
        }

        return <ListView {...viewProps} />;
    }

    onChange(){
        const accessGroups = AccessGroupStore.getAll({limit: this.state.limit});
        if (accessGroups !== undefined) {
            this.setState({accessGroups: accessGroups});
        }
    }
}

AccessGroupList.contextTypes = {
    auth: PropTypes.object.isRequired
};

export default AccessGroupList;
